var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Countdown',{attrs:{"endYear":"2022","endMonth":"4","endDay":"23","endHour":"18","endMinute":"30","isUTC":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }